import { useState } from 'react';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import { getSettingsWiseReport } from '@api/getSettingsWiseCsv';

export const useDashboardElectionSettingsWiseCsv = () => {
  const [dashboardElectionWiseCsvData, setDashboardElectionWiseCsvData] =
    useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getDashboardElectionSettingsWiseCsv = async ({
    election_schedule_id,
    time_range,
  }: {
    election_schedule_id: number | string;
    time_range?: string;
  }) => {
    setIsLoading(true);
    try {
      const response = await getSettingsWiseReport({
        election_schedule_id,
        time_range,
      });

      if (response?.data) {
        setDashboardElectionWiseCsvData(response?.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setDashboardElectionWiseCsvData([]);
        toast.error(t('DASHBOARD.DOWNLOAD_ERROR'));
      }
    } catch (error) {
      setIsLoading(false);
      setDashboardElectionWiseCsvData([]);
      toast.error(t('DASHBOARD.DOWNLOAD_ERROR'));
    }
  };
  return {
    getDashboardElectionSettingsWiseCsv,
    dashboardElectionWiseCsvData,
    isLoading,
  };
};
